module.exports = __webpack_public_path__ + "img/3.76d33acb.jpg";